export default from './trimResultTransformer';
